// Brand pill/badge color mapping — applied wherever a brand pill appears (tables, tooltips, etc.)
// NOTE: Chart fills (pie slices, legend dots) continue to use BRAND_COLORS solid fills defined locally in chart files.
export const BRAND_PILL_COLORS = {
  Wellcore:     { bg: "#E1F5EE", text: "#085041" },
  Dynamite:     { bg: "#FFF0E6", text: "#7A3000" },
  YouWeFit:     { bg: "#FFFBE6", text: "#7A5C00" },
  Okami:        { bg: "#FCEBEB", text: "#A32D2D" },
  OSMO:         { bg: "#E6F1FB", text: "#0C447C" },
  "Zero Sugar": { bg: "#EAF3DE", text: "#27500A" },
};

const FALLBACK_PILL = { bg: "#F1F5F9", text: "#475569" };

export const getBrandPillStyle = (brand) => BRAND_PILL_COLORS[brand] || FALLBACK_PILL;
